<template>
<div v-if="detailedTeam">
    <messageModal v-if="showMessage" message="vos modifications ont été prises en compte !" @closeMessage="goToDetail"></messageModal>
    <div class="panel">
        <team-detail-header :actions="false" :team="detailedTeam"></team-detail-header>
        <div class="panel-content panel-top">
        <div class="row columns">
            <div class="large-12">
                <table>
                    <thead class="roster">
                        <tr>
                            <th width="70">N°</th>
                            <th width="150">Nom</th>
                            <th width="150">Position</th>
                            <th width="10">M</th>
                            <th width="10">F</th>
                            <th width="10">Ag</th>
                            <th width="10">Ar</th>
                            <th width="250">Compétences</th>
                            <th width="100">Prix</th>
                        </tr>
                    </thead>
                    <tbody class="roster">
                        <tr v-for="player,cpt in detailedTeam.players">
                            <td class="number">
                                <input v-model="playerDatas[cpt].num" class="player-name" type="number">
                            </td>
                            <td v-bind:class="{ miss: player.miss_next_game }" >
                                <input v-model="playerDatas[cpt].name" class="player-name" type="text">
                            </td>
                            <td >{{player.ref_roster_line}}</td>
                            <td >{{player.M}}</td>
                            <td >{{player.F}}</td>
                            <td >{{player.Ag}}</td>
                            <td >{{player.Ar}}</td>
                            <td>
                                <span v-for="skill in player.skills" >
                                        {{skill.name}},
                                </span>
                            </td>
                            <td><span class="additional_skills">{{player.base_cost}}k</span></td>
                        </tr>
                        <tr>
                            <td colspan="8" class="sous-total right">
                                <div class="row columns">
                                    <div class="large-5 columns">{{detailedTeam.players.length}} Joueurs</div>
                                    <div class="large-1 large-offset-5 columns">total</div>
                                </div>
                            </td>
                            <td class="sous-total">{{playersCost}}k</td>
                        </tr>
                    </tbody>
                </table>
                <div class="row columns">
                    <div class="large-centered">
                        <div class="error-lbl" v-if="error">{{errorMessage}}</div>
                    </div>
                    <br>
                </div>
                <div class="row columns">
                    <div class="large-2 columns">
                        <router-link :to="{ name: 'TeamDetail', params: { id: detailedTeam.id.toString() }}" >
                            <button class="light-grey-button full-width">annuler</button>
                        </router-link>
                    </div>
                    <div class="large-2 right columns">
                        <button @click="validate" class="full-width">Valider</button>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <hr>
    </div>
</div>
<div v-else>
  <spinner></spinner>
</div>
</template>

<script>
import store from '../../store/index.js'
import spinner from '../common/spinner.vue'
import messageModal from '../common/message-modal.vue'
import teamDetailHeader from './team-header/team-detail-header.vue'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import player from '../../api/player.api'

export default {
  name: 'teamEdit',
  components: {
    spinner,
    teamDetailHeader,
    messageModal
  },
  props: {
    'id': String
  },
  data () {
    return {
      playerDatas: [],
      isPlayerDatasInit: false,
      error: false,
      errorMessage: '',
      showMessage: false
    }
  },
  computed:
  {
    ...mapGetters([
      'detailedTeam'
    ]),
    playersCost: function (onlyPlaying = true) {
      let playerCost = 0
      this.detailedTeam.players.forEach(player => {
        if (!onlyPlaying || !player.miss_next_game) {
          playerCost += (player.base_cost + player.evolution_cost)
        }
      })
      return playerCost
    }
  },
  methods: {
    goToDetail () {
      this.showMessage = false
      this.$router.push({name: 'TeamDetail', params: { id: this.detailedTeam.id.toString() }})
    },
    initPlayerDatas () {
      for (let i = 0; i < this.detailedTeam.players.length; i++) {
        var p = {}
        p.id = this.detailedTeam.players[i].id
        p.name = this.detailedTeam.players[i].name
        p.num = this.detailedTeam.players[i].num
        Vue.set(this.playerDatas, i, p)
      }
      this.isPlayerDataInit = true
    },
    validate () {
      let conflictNum = this.checkDifferentNumbers()
      if (conflictNum !== -1) {
        this.error = true
        this.errorMessage = 'vous avez deux n°' + conflictNum + ', et c\'est pas glop'
        return
      }
      player.api.bulkUpdatePlayer(this.playerDatas)
      .then(response => {
        this.showMessage = true
      }, error => {
        console.log('impossible to bulk update players')
        console.log(error)
      })
    },
    checkDifferentNumbers () {
      for (let i = 0; i < this.detailedTeam.players.length; i++) {
        for (let j = 0; j < this.detailedTeam.players.length; j++) {
          if (i === j) {
            continue
          }
          if (this.playerDatas[i].num !== this.playerDatas[j].num) {
            continue
          } else {
            return this.playerDatas[i].num
          }
        }
      }
      return -1
    }
  },
  created () {
    store.dispatch('hideLeaguePanel')
    store.dispatch('deactivateFullSizePage')
    store.dispatch('getDetailedTeam', this.id.toString())
    let unsuscribe = store.subscribe((mutation, state) => {
      if (mutation.type === 'updateDetailedTeam') {
        if (!this.isPlayerDatasInit) {
          this.initPlayerDatas()
        } else {
          unsuscribe()
        }
      }
    })
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.roster{
    font-weight: 300;
}

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

.roster tr td.number {
    padding: 0rem 0.2rem;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

.roster tr td{
    padding: 0.5rem 0rem;
    text-align: center;
    font-size:0.7rem;
}

.roster tr td.sous-total{
    font-weight: 400;
    padding: 0.4rem 0rem;
}


.roster tr td.sous-total.right{

}

button.row{
    margin-left: 0.4rem;
}

.team-score {
    font-size: 2rem;
    font-weight: 450;
    padding-top: 1rem;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}

.match-result {
    font-size: 1.2rem;
    font-weight: 200;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}

.match-team-name {
    font-size: 1.7rem;
    font-weight: 300;
    padding-top: 1rem;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}
.player-name {
    margin: 0rem;
}
.panel-top {
    padding-top: 0rem;
}
</style>



// WEBPACK FOOTER //
// team-edit.vue?152c6922